import { render } from "./OwnersView.vue?vue&type=template&id=03fe3fa8&scoped=true"
import script from "./OwnersView.vue?vue&type=script&lang=js"
export * from "./OwnersView.vue?vue&type=script&lang=js"

import "./OwnersView.vue?vue&type=style&index=0&id=03fe3fa8&scoped=true&lang=css"
import "./OwnersView.vue?vue&type=style&index=1&id=03fe3fa8&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=2&lang=css"

import exportComponent from "/var/www/www.newtoncommoditiesscripts.com/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03fe3fa8"]])

export default __exports__